/** @format */

import { Component, Input } from '@angular/core';

import { IHomrBanner } from '@shared/data-access/interfaces';

@Component({
    selector: 'pdp-homr-banner',
    templateUrl: './homr-banner.component.html',
    styleUrls: ['./homr-banner.component.scss'],
    standalone: false
})
export class HomrBannerComponent {
	@Input() data: IHomrBanner;
}
